import React from 'react';
import classNames from 'classnames';
import { sanitizeHTML } from '@benzinga/frontend-utils';
import styles from './ArticleBody.module.scss';

interface Props {
  body: string;
}

interface ArticleBodyContentProps {
  isBot?: boolean;
  isPaywalled?: boolean;
  isSponsored?: boolean;
  children: React.ReactNode;
}

export const ArticleBody = ({ body }: Props) => (
  <div
    className={`${styles.body} article-content-body-only`}
    dangerouslySetInnerHTML={{ __html: sanitizeHTML(body) }}
    id="article-body"
    itemProp="articleBody"
  />
);

export const ArticleBodyContent = ({ children, isBot, isPaywalled, isSponsored }: ArticleBodyContentProps) => {
  return (
    <div
      className={classNames(styles.body, 'article-content-body-only', {
        'article-content-paywalled': !isBot && !isSponsored && isPaywalled,
      })}
      id="article-body"
      itemProp="articleBody"
    >
      {children}
    </div>
  );
};
